document.addEventListener("DOMContentLoaded", function () {
  var root = document.querySelector(".product-page");
  if (!root) return;

  var gallery = root.querySelector(".product-gallery-grid");
  var mediaEls = gallery
    ? Array.from(gallery.querySelectorAll(".product-media"))
    : [];
  var prevBtn = root.querySelector(".gallery-arrow--prev");
  var nextBtn = root.querySelector(".gallery-arrow--next");
  var modal = root.querySelector(".image-modal");
  var modalImg = modal ? modal.querySelector(".image-modal__img") : null;
  var modalClose = modal ? modal.querySelector(".image-modal__close") : null;
  var modalBackdrop = modal
    ? modal.querySelector(".image-modal__backdrop")
    : null;
  var modalViewport = modal
    ? modal.querySelector(".image-modal__viewport")
    : null;

  var priceEl = root.querySelector(".product-price");
  var variantIdInput = root.querySelector(".product-variant-id");
  var sizesContainer = root.querySelector(".product-sizes");
  var productForm =
    root.querySelector('form[action*="/cart/add"]') ||
    root.querySelector("form");
  var colorInputs = Array.from(
  root.querySelectorAll(".product-colors .cp-swatch__input")
);
var hasColors = colorInputs.length > 0;


  var addButton = root.querySelector(".product-add");

  var dataEl = document.querySelector(
    "#ProductData-" + root.id.replace("Product-", "")
  );
  var variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    variants = [];
  }

  var productId = root.getAttribute("data-product-id") || "";
  var currency = root.getAttribute("data-currency") || "BRL";

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ç/g, "c")
      .replace(/[^a-z0-9]+/g, "-");
  }

  // ---------- Estado do botão "Adicionar ao carrinho" ----------

  function setAddButtonDisabled(disabled) {
    if (!addButton) return;

    if (disabled) {
      addButton.disabled = true;
      addButton.classList.add("product-add--disabled");
    } else {
      addButton.disabled = false;
      addButton.classList.remove("product-add--disabled");
    }
  }

  if (modalViewport) {
    modalViewport.addEventListener("click", function (e) {
      if (!modal || !modalImg) return;
      if (e.target === modalImg) return;
      modal.classList.remove("is-open");
      modalImg.src = "";
    });
  }

  function currentColor() {
    var checked = colorInputs.find(function (i) {
      return i.checked;
    });
    var h = checked ? checked.dataset.colorHandle || "" : "";
    if (!h && variantIdInput && variants.length) {
      var v = variants.find(function (v) {
        return String(v.id) === String(variantIdInput.value);
      });
      if (v && v.option1) {
        h = v.option1;
      }
    }
    return norm(h);
  }

  function currentColorRaw() {
    var checked = colorInputs.find(function (i) {
      return i.checked;
    });
    if (checked) {
      return checked.dataset.colorName || checked.value;
    }
    if (variantIdInput && variants.length) {
      var v = variants.find(function (v) {
        return String(v.id) === String(variantIdInput.value);
      });
      if (v && v.option1) {
        return v.option1;
      }
    }
    return "";
  }

  function currentSize() {
    var checked = sizesContainer
      ? sizesContainer.querySelector(".size-swatch__input:checked")
      : null;
    return checked ? checked.value : "";
  }

  function allowedMediaIdsForColor() {
    var targetColor = currentColorRaw();
    var ids = new Set();
    variants.forEach(function (v) {
      if (v.option1 === targetColor && v.featured_media && v.featured_media.id)
        ids.add(String(v.featured_media.id));
    });
    return ids;
  }

  function mediaSrcMatches(el, handle) {
    if (!handle) return true;
    var img = el.querySelector("img");
    var vid = el.querySelector("video");
    var ifr = el.querySelector("iframe");
    var srcs = [];
    if (img) {
      if (img.currentSrc) srcs.push(String(img.currentSrc));
      if (img.src) srcs.push(String(img.src));
    }
    if (vid) {
      if (vid.src) srcs.push(String(vid.src));
      el.querySelectorAll("video source").forEach(function (s) {
        if (s.src) srcs.push(String(s.src));
      });
    }
    if (ifr && ifr.src) srcs.push(String(ifr.src));
    var h = String(handle).toLowerCase();
    return srcs.some(function (s) {
      s = String(s).toLowerCase();
      return (
        s.indexOf("-" + h) !== -1 ||
        s.indexOf("_" + h) !== -1 ||
        s.indexOf("/" + h + "_") !== -1 ||
        s.indexOf("/" + h + "/") !== -1
      );
    });
  }

  function matchesHandle(el, handle) {
    var h = norm(el.getAttribute("data-color-handle") || "");
    if (!handle) return true;
    return (
      (h && (h.indexOf(handle) !== -1 || handle.indexOf(h) !== -1)) ||
      mediaSrcMatches(el, handle)
    );
  }

  function filterMediaByColor(handle) {
    var h = String(handle || "");
    var boundary = {};
    variants.forEach(function (v) {
      if (v && v.featured_media && v.featured_media.id) {
        boundary[String(v.featured_media.id)] = norm(v.option1);
      }
    });

    var startIndex = -1;
    for (var i = 0; i < mediaEls.length; i++) {
      var mid = String(mediaEls[i].getAttribute("data-media-id") || "");
      var col = boundary[mid];
      if (typeof col !== "undefined" && col === h) {
        startIndex = i;
        break;
      }
    }

    if (startIndex < 0) {
      for (var k = 0; k < mediaEls.length; k++) {
        var eh = norm(mediaEls[k].getAttribute("data-color-handle") || "");
        if ((eh && eh === h) || (!eh && mediaSrcMatches(mediaEls[k], h))) {
          startIndex = k;
          break;
        }
      }
    }

    var stopIndex = -1;
    if (startIndex >= 0) {
      for (var j = startIndex + 1; j < mediaEls.length; j++) {
        var midNext = String(mediaEls[j].getAttribute("data-media-id") || "");
        var colNext = boundary[midNext];
        if (typeof colNext !== "undefined" && colNext !== h) {
          stopIndex = j;
          break;
        }
      }
      mediaEls.forEach(function (el, idx) {
        var show = idx >= startIndex && (stopIndex < 0 || idx < stopIndex);
        if (show) {
          el.classList.remove("is-hidden");
        } else {
          el.classList.add("is-hidden");
        }
      });
    } else {
      var visible = 0;
      mediaEls.forEach(function (el) {
        var eh = norm(el.getAttribute("data-color-handle") || "");
        var match = (eh && eh === h) || (!eh && mediaSrcMatches(el, h));
        if (match) {
          el.classList.remove("is-hidden");
          visible++;
        } else {
          el.classList.add("is-hidden");
        }
      });
      if (visible === 0) {
        mediaEls.forEach(function (el) {
          el.classList.add("is-hidden");
        });
      }
    }
  }

  var currentIndex = 0;

  function visibleMedia() {
    return mediaEls.filter(function (el) {
      return !el.classList.contains("is-hidden");
    });
  }

  function scrollToIndex(i) {
    var v = visibleMedia();
    if (!v.length) return;
    currentIndex = Math.max(0, Math.min(i, v.length - 1));
    var target = v[currentIndex];
    var first = v[0];
    var dx = target.offsetLeft - (first ? first.offsetLeft : 0);
    if (gallery) gallery.scrollTo({ left: dx, behavior: "smooth" });
    updateArrows();
  }

  function updateArrows() {
    if (!prevBtn || !nextBtn) return;
    var v = visibleMedia();
    prevBtn.disabled = currentIndex <= 0 || v.length <= 1;
    nextBtn.disabled = currentIndex >= v.length - 1 || v.length <= 1;
  }

  function updateCarouselVisible() {
    currentIndex = 0;
    updateArrows();
    scrollToIndex(currentIndex);
  }

  if (prevBtn)
    prevBtn.addEventListener("click", function () {
      scrollToIndex(currentIndex - 1);
    });
  if (nextBtn)
    nextBtn.addEventListener("click", function () {
      scrollToIndex(currentIndex + 1);
    });

  function setupZoom() {
    mediaEls.forEach(function (card) {
      var img = card.querySelector(".product-media__image");
      if (!img) return;

      function largestSrc(i) {
        var ss = String(i.srcset || "");
        var parts = ss
          .split(",")
          .map(function (x) {
            return x.trim();
          })
          .filter(Boolean);
        if (parts.length) {
          var last = parts[parts.length - 1];
          var url = last.split(" ")[0];
          return url;
        }
        return i.currentSrc || i.src || "";
      }

      function openModal(src, alt) {
        if (!modal || !modalImg) return;
        modalImg.src = src;
        modalImg.alt = alt || "";
        modal.classList.add("is-open");
        var s = 1;
        var tx = 0;
        var ty = 0;
        var startX = 0;
        var startY = 0;
        var s0 = 1;
        var pinStart = 0;

        function set() {
          modalImg.style.transform =
            "translate(" + tx + "px," + ty + "px) scale(" + s + ")";
        }

        modalImg.style.transform = "translate(0,0) scale(1)";

        if (modalClose)
          modalClose.onclick = function () {
            modal.classList.remove("is-open");
            modalImg.src = "";
          };
        if (modalBackdrop)
          modalBackdrop.onclick = function () {
            modal.classList.remove("is-open");
            modalImg.src = "";
          };

        modalImg.addEventListener(
          "mousedown",
          function (e) {
            startX = e.clientX;
            startY = e.clientY;
            function mm(ev) {
              tx += ev.clientX - startX;
              ty += ev.clientY - startY;
              startX = ev.clientX;
              startY = ev.clientY;
              set();
            }
            function mu() {
              document.removeEventListener("mousemove", mm);
              document.removeEventListener("mouseup", mu);
            }
            document.addEventListener("mousemove", mm);
            document.addEventListener("mouseup", mu);
          },
          { passive: true }
        );

        modalImg.addEventListener(
          "wheel",
          function (e) {
            e.preventDefault();
            var factor = e.deltaY > 0 ? 0.9 : 1.1;
            s = Math.max(1, Math.min(4, s * factor));
            set();
          },
          { passive: false }
        );

        modalImg.addEventListener(
          "touchstart",
          function (e) {
            if (e.touches.length === 2) {
              var a = e.touches[0],
                b = e.touches[1];
              pinStart = Math.hypot(
                b.clientX - a.clientX,
                b.clientY - a.clientY
              );
              s0 = s;
            } else if (e.touches.length === 1) {
              startX = e.touches[0].clientX;
              startY = e.touches[0].clientY;
            }
          },
          { passive: false }
        );

        modalImg.addEventListener(
          "touchmove",
          function (e) {
            if (e.touches.length === 2) {
              var a = e.touches[0],
                b = e.touches[1];
              var d = Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
              s = Math.max(1, Math.min(4, (s0 * d) / pinStart));
              set();
            } else if (e.touches.length === 1) {
              var x = e.touches[0].clientX;
              var y = e.touches[0].clientY;
              tx += x - startX;
              ty += y - startY;
              startX = x;
              startY = y;
              set();
            }
          },
          { passive: false }
        );

        modalImg.addEventListener(
          "touchend",
          function (e) {
            if (e.touches.length === 0 && s <= 1) {
              modalImg.style.transform = "translate(0,0) scale(1)";
            }
          },
          { passive: true }
        );
      }

      img.addEventListener(
        "click",
        function () {
          openModal(largestSrc(img), img.alt || "");
        },
        { passive: true }
      );
    });
  }

  function initialColorHandle() {
    try {
      var href = String(window.location.href || "");
      var url = new URL(href);
      var variantParam = url.searchParams.get("variant");
      if (variantParam) {
        var v = variants.find(function (x) {
          return String(x.id) === String(variantParam);
        });
        if (v && v.option1) {
          return norm(v.option1);
        }
      }
      var colorParam =
        url.searchParams.get("color") || url.searchParams.get("cor");
      if (colorParam) {
        return norm(colorParam);
      }
      var stored = sessionStorage.getItem("prod:" + productId + ":color");
      if (stored) {
        return stored;
      }
      var raw = currentColorRaw();
      if (raw) {
        return norm(raw);
      }
      var first = variants.find(function (v) {
        return v.available;
      });
      if (first && first.option1) {
        return norm(first.option1);
      }
      return norm(variants[0] ? variants[0].option1 : "");
    } catch (_) {
      return norm(currentColorRaw() || "");
    }
  }

  function setColorChecked(handle) {
    if (!colorInputs.length) return;
    var h = String(handle || "");
    colorInputs.forEach(function (inp) {
      var ih = String(inp.dataset.colorHandle || norm(inp.value));
      inp.checked = ih === h;
    });
  }

  function chooseVariant() {
    if (!variants.length || !variantIdInput) return;
    var targetColor = currentColorRaw();
    var targetSize = currentSize();

    var match = variants.find(function (v) {
      return (
        v.option1 === targetColor &&
        (targetSize ? v.option2 === targetSize : true) &&
        v.available
      );
    });

    if (!match) {
      match =
        variants.find(function (v) {
          return v.option1 === targetColor && v.available;
        }) || variants[0];
    }

    if (match) {
      variantIdInput.value = String(match.id);
      updatePrice(match.price);
      updateUrlAfterVariant();
    }
  }

  // ---------- Tamanhos por cor + bloqueio do botão ----------

  function syncSizesForColor() {
    if (!sizesContainer || !variants.length) {
      setAddButtonDisabled(false);
      return;
    }

    var targetColor = currentColorRaw();
    if (!targetColor) {
      setAddButtonDisabled(false);
      return;
    }

    // Mapa tamanho -> { available: boolean }
    var bySize = new Map();

    variants.forEach(function (v) {
      if (v.option1 !== targetColor) return;
      var size = v.option2;
      if (!size) return;

      // ⚠️ Se usar "continuar vendendo sem estoque", troque para inventory_quantity > 0
      var isAvailable = v.available; // ou: v.inventory_quantity > 0

      if (!bySize.has(size)) {
        bySize.set(size, { available: isAvailable });
      } else {
        var info = bySize.get(size);
        info.available = info.available || isAvailable;
        bySize.set(size, info);
      }
    });

    // Variante atual (pra saber qual tamanho marcar como checked)
    var current = variants.find(function (v) {
      return String(v.id) === String(variantIdInput && variantIdInput.value);
    });
    var currentSize = current ? current.option2 : "";

        var html = "";
    var hasAvailableSize = false;

    Array.from(bySize.keys()).forEach(function (size) {
      var info = bySize.get(size);
      var isSoldOut = !info.available;

      if (info.available) hasAvailableSize = true;

      // Só deixa marcado se for o tamanho atual E não estiver esgotado
      var checked =
        !isSoldOut &&
        currentSize &&
        String(size) === String(currentSize)
          ? " checked"
          : "";

      // Tamanho esgotado não pode nem ser selecionado
      var disabledAttr = isSoldOut ? " disabled" : "";

      html +=
        '<label class="size-swatch' +
        (isSoldOut ? " size-swatch--sold-out" : "") +
        '">' +
        '<input type="radio" class="size-swatch__input" name="size" value="' +
        size +
        '"' +
        checked +
        disabledAttr +
        ' data-size="' +
        size +
        '" data-sold-out="' +
        (isSoldOut ? "true" : "false") +
        '">' +
        '<span class="size-swatch__label' +
        (isSoldOut ? " size-swatch__label--sold-out" : "") +
        '">' +
        size +
        "</span>" +
        "</label>";
    });

    sizesContainer.innerHTML = html;


    // Se não houver nenhum tamanho disponível para a cor atual -> bloqueia o botão
    if (!bySize.size || !hasAvailableSize) {
      setAddButtonDisabled(true);
    } else {
      setAddButtonDisabled(false);
    }

    Array.from(sizesContainer.querySelectorAll(".size-swatch__input")).forEach(
      function (inp) {
        inp.addEventListener(
          "change",
          function () {
            chooseVariant();
            updateUrlAfterVariant();
          },
          { passive: true }
        );
      }
    );
  }

  function updatePrice(cents) {
    if (!priceEl) return;
    var priceContainer = root.querySelector(".product-price");
    var priceCurrentEl = priceContainer ? priceContainer.querySelector(".price-current") : null;
    var priceCompareEl = priceContainer ? priceContainer.querySelector(".price-compare") : null;
    var badgeEl = priceContainer ? priceContainer.querySelector(".discount-badge") : null;

    var amt = (Number(cents) || 0) / 100;
    var str = "";
    try {
      str = amt.toLocaleString(undefined, {
        style: "currency",
        currency: currency,
      });
    } catch (_) {
      str = (currency === "BRL" ? "R$ " : "") + amt.toFixed(2);
    }

    if (priceCurrentEl) {
      priceCurrentEl.textContent = str;
    } else if (priceEl) {
      priceEl.textContent = str;
    }

    var cashbackEl = document.querySelector(".cashback-value");
    var cashbackBanner = document.querySelector(".cashback-banner");
    if (cashbackEl && cashbackBanner) {
      var pct = parseFloat(cashbackBanner.dataset.cashbackPercentage || 10);
      var cbVal = Math.round(cents * pct / 100);
      var cbStr = "";
      try {
        cbStr = (cbVal / 100).toLocaleString(undefined, {
          style: "currency",
          currency: currency,
        });
      } catch (_) {
        cbStr = (currency === "BRL" ? "R$ " : "") + (cbVal / 100).toFixed(2);
      }
      cashbackEl.textContent = cbStr;
    }

    var installmentEl = document.querySelector(".cp-installment");
    if (installmentEl && root.dataset.installmentEnable === "true") {
      var installments = parseInt(root.dataset.installmentInstallments || 3);
      var suffix = root.dataset.installmentSuffix || "sem juros";
      var instVal = Math.round(cents / installments);
      var instStr = "";
      try {
        instStr = (instVal / 100).toLocaleString(undefined, {
          style: "currency",
          currency: currency,
        });
      } catch (_) {
        instStr = (currency === "BRL" ? "R$ " : "") + (instVal / 100).toFixed(2);
      }
      installmentEl.innerHTML = installments + "x de " + instStr + " " + suffix;
    }
  }

  colorInputs.forEach(function (i) {
    i.addEventListener(
      "change",
      function () {
        var h = currentColor();
        sessionStorage.setItem("prod:" + productId + ":color", h);

        if (hasColors) {
          filterMediaByColor(h);
        }

        updateCarouselVisible();
        syncSizesForColor();
        chooseVariant();
        updateUrlAfterVariant();
      },
      { passive: true }
    );
  });

  function updateUrlAfterVariant() {
    if (!variantIdInput) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set("variant", String(variantIdInput.value || ""));
      u.searchParams.delete("color");
      u.searchParams.delete("cor");
      history.replaceState(null, "", u.toString());
    } catch (_) {}
  }

var initH = hasColors ? initialColorHandle() : "";

if (hasColors) {
  setColorChecked(initH);
  filterMediaByColor(initH);
} else {
  // Produto SEM cor: garante que nenhuma mídia fique escondida
  mediaEls.forEach(function (el) {
    el.classList.remove("is-hidden");
  });
}

setupZoom();
updateCarouselVisible();
syncSizesForColor();
chooseVariant();
updateUrlAfterVariant();



  if (productForm) {
    productForm.addEventListener(
      "submit",
      function (event) {
        // Se o botão estiver desabilitado, não deixa nem tentar enviar
        if (addButton && addButton.disabled) {
          event.preventDefault();
          return;
        }
        chooseVariant();
        updateUrlAfterVariant();
      },
      { passive: false }
    );
  }
});
